import React from "react";
import { BRAND } from "@/lib/brand";

// ── Wordmark: "חשבית" with a green dagesh-style dot centered inside the ב ──
// The dot is an absolutely-positioned element centered in the ב's box, so it
// sits in the counter (open space) and not on the strokes — and scales with font-size.
export function Wordmark({ className = "", gradient = false }) {
  const { before, dot, after } = BRAND.wordmark;
  return (
    <span
      dir="rtl"
      aria-label={BRAND.name}
      className={`font-heading font-extrabold tracking-tight ${gradient ? "gradient-text" : ""} ${className}`}
    >
      <span aria-hidden="true">{before}</span>
      <span
        aria-hidden="true"
        className="relative inline-block leading-none"
        style={{ fontSize: "1.1em", transform: "rotate(7deg)", transformOrigin: "center" }}
      >
        {dot}
        <span
          aria-hidden="true"
          className="absolute rounded-full"
          style={{
            width: "0.15em",
            height: "0.15em",
            backgroundColor: BRAND.dotColor,
            left: "40%",
            top: "45%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </span>
      <span aria-hidden="true">{after}</span>
    </span>
  );
}

// ── BrandIcon: rounded purple-gradient square with the letter ב + green dagesh ──
// Used for the header/sidebar mark, favicon and WhatsApp/social avatar.
export function BrandIcon({ size = 40, className = "" }) {
  // id ייחודי לכל instance — id קבוע נכשל כשיש כמה BrandIcons או כשה-def בתת-עץ מוסתר (ה-ב יוצא ריק)
  const gradId = "heshbit-grad-" + React.useId().replace(/[^a-zA-Z0-9]/g, "");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      className={className}
      role="img"
      aria-label={BRAND.name}
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#6d28d9" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="48" height="48" rx="13" fill={`url(#${gradId})`} />
      <g transform="rotate(6 24 24)">
        <text
          x="24"
          y="35"
          textAnchor="middle"
          fontFamily="'Heebo','Assistant',Arial,sans-serif"
          fontSize="31"
          fontWeight="800"
          fill="#ffffff"
        >
          ב
        </text>
        <circle cx="20" cy="25" r="3.2" fill={BRAND.dotColor} />
      </g>
    </svg>
  );
}

export default Wordmark;
